<template>
    <div class="field">
        <label class="label">Transfer this User</label>
        <div class="control">
            <a class="button is-danger is-fullwidth" @click.prevent="transferUserModal(user)">Current manager: {{ user.manager.name }}</a>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['user'],
        methods: {
            transferUserModal(user) {
                this.$store.dispatch('setUserTransferUserId', user.id)
                this.$store.dispatch('setUserTransferModalStatus', true)
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Users/User/Inputs/TransferUser.vue